<template>
  <div class="home">
    <HeroSection />
  </div>
</template>

<script>
// @ is an alias to /src
import HeroSection from '@/components/hero-section.vue'

export default {
  name: 'Home',
  components: {
    HeroSection
  }
}
</script>
